module.exports = "/build/web/images/logo-sigma.f02f3cc0a1149916807752cd515f8dbb.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo-sigma.png
// module id = 125
// module chunks = 11